// src/Components/NicheShared/NicheHero.tsx
import React from "react";
import styled from "styled-components";
import Container from "../Container";
import ButtonTestFree from "../ButtonTestFree";
import Typewriter from "typewriter-effect";

interface NicheHeroProps {
  headline: string;
  subheadline: string;
  id?: string;
}

const Title = styled.h1`
  font-weight: 300;
  font-size: 65px;
  color: #fff;
  min-height: 450px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 0 auto;

  @media (max-width: 768px) {
    font-size: 40px;
    min-height: 300px;
  }
`;

const SpanText = styled.span`
  font-weight: 200;
  font-size: 20px;
  line-height: 30px;
  color: #fff;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

const NicheHero: React.FC<NicheHeroProps> = ({ headline, subheadline, id }) => (
  <Container
    id={id}
    style={{ textAlign: "center", paddingTop: "120px", paddingBottom: "80px", background: "#000000" }}
  >
    <Title>
      <Typewriter
        onInit={(typewriter) => {
          typewriter.typeString(headline).start();
        }}
        options={{
          autoStart: true,
          loop: false,
          delay: 50,
        }}
      />
    </Title>
    <SpanText>{subheadline}</SpanText>
    <ButtonTestFree />
    <SpanText style={{ fontSize: "15px" }}>
      <span style={{ fontWeight: 400 }}>Sem cartão de crédito. Configuração em minutos</span>
    </SpanText>
  </Container>
);

export default NicheHero;
